/**
 * One-time migration: rename any localStorage/sessionStorage keys that start with
 * "flirt" (legacy brand) to "zappy" (new brand). Preserves values, removes the
 * legacy key. Idempotent: a flag is stored so subsequent boots skip the work.
 *
 * Renamed July 2026 as part of the Flirt → Zappy rebrand.
 */
const MIGRATION_FLAG = "zappy.brand-migration.v1";

function migrateStorage(storage: Storage) {
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const k = storage.key(i);
    if (k && /^flirt[._\-:]?/i.test(k)) keys.push(k);
  }
  for (const oldKey of keys) {
    try {
      const value = storage.getItem(oldKey);
      if (value === null) continue;
      const newKey = oldKey.replace(/^flirt/i, (m) =>
        m[0] === "F" ? "Zappy" : "zappy"
      );
      if (!storage.getItem(newKey)) storage.setItem(newKey, value);
      storage.removeItem(oldKey);
    } catch {
      /* ignore */
    }
  }
}

export function migrateLegacyBrandStorage() {
  if (typeof window === "undefined") return;
  try {
    if (window.localStorage.getItem(MIGRATION_FLAG)) return;
    migrateStorage(window.localStorage);
    try { migrateStorage(window.sessionStorage); } catch { /* noop */ }
    window.localStorage.setItem(MIGRATION_FLAG, String(Date.now()));
  } catch {
    /* noop */
  }
}
